<!-- HOME PAGE -->
<div class="container">
  <!-- HEADER PAGE -->

  <!-- ROW TITLE -->
  <div fxLayout="row wrap" fxLayoutAlign="center">

    <div fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <!-- TITLE -->
      <div class="title alicent">
        A solution for every need
      </div>
    </div>

  </div>

  <!-- ROW INTRO -->
  <div fxLayout="row wrap" fxLayoutAlign="center">
    <div fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">

      <!-- INTRO -->
      <div class="paragraph alijust">
        <p data-aos="fade-down-right">We provide patient-centric digital solutions to boost <span>patient recruitment
            and retention</span> in your study, improve <span>clinical data quality</span>, and <span>lower the
            administrative burden of patient
            reimbursement</span>. These include off-the-shelf and fully customizable offerings whose purpose is to help
          you push
          your study through the typical clinical trial bottlenecks. ​</p>
      </div>
    </div>
  </div>

  <!-- ROW ECONSENT -->
  <div fxLayout="row wrap" fxLayoutAlign="center" class="rowdiv">
    <!-- TEXT -->
    <div fxFlex.xl="19" fxFlex.lg="19" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="paragraph">
        <h2 data-aos="fade-down-right" class="alicent">eConsent</h2>
        <p data-aos="fade-down-right">
          The <b>eCONSENT</b> form facilitates patient inclusion through an <span>interactive consent platform</span>
          and connects your study team and IRBs to the <span>inclusion real-time</span>.​
        </p>
      </div>
    </div>

    <!-- SPACER -->
    <div fxFlex.xl="2" fxFlex.lg="2"></div>

    <!-- IMG -->
    <div fxFlex.xl="19" fxFlex.lg="19" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="" data-aos="fade-down-right">
        <div class="rowdiv wrapper">
          <img class="img-responsive" src="assets/medias/img/mockup-consent.webp" alt="econsent" />
        </div>
      </div>
    </div>

  </div>

  <!-- ROW EVISIT PLANNER -->
  <div fxLayout="row wrap" fxLayoutAlign="center" class="rowdiv" dir="rtl">

    <!-- TEXT -->
    <div fxFlex.xl="19" fxFlex.lg="19" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="paragraph" dir="ltr">
        <h2 data-aos="fade-down-right" class="alicent">eVisit Planner</h2>
        <p data-aos="fade-down-right">
          The evisit planner takes the stress out of study visits organization for the patient. The patient gets an
          <span>automatic reminder of the upcoming visit period</span>, together
          <span>with travel and accommodation options</span> whose total cost is pre-defined by the sponsor. The sponsor
          receives <span>e-receipts packages</span> through the platform.
        </p>
      </div>
    </div>

    <!-- SPACER -->
    <div fxFlex.xl="2" fxFlex.lg="2"></div>

    <!-- IMG -->
    <div fxFlex.xl="19" fxFlex.lg="19" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="" data-aos="fade-down-right">
        <div class="rowdiv wrapper">
          <img class="img-responsive" src="assets/medias/img/Composition 1_8g.gif" alt="evisit" />
        </div>
      </div>
    </div>
  </div>

  <!-- ROW ePRO QUESTIONNAIRES -->
  <div fxLayout="row wrap" fxLayoutAlign="center" class="rowdiv">
    <!-- TEXT -->
    <div fxFlex.xl="19" fxFlex.lg="19" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="paragraph">
        <h2 data-aos="fade-down-right" class="alicent">
          ePro Questionnaires
          (Android &amp; iOS)</h2>
        <p data-aos="fade-down-right">
          The patient downloads the ePRO questionnaires through Android or iOS app store. He/she gets <span>a reminder
            to fill in the questionnaire</span> at the times indicated in the study protocol. <span>Error messages for
            missing or incoherent</span> are pre-programmed to ensure the collection of clean data.
        </p>
      </div>
    </div>

    <!-- SPACER -->
    <div fxFlex.xl="2" fxFlex.lg="2"></div>

    <!-- IMG -->
    <div fxFlex.xl="19" fxFlex.lg="19" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <div class="" data-aos="fade-down-right">
        <div class="rowdiv wrapper">
          <img class="img-responsive" src="assets/medias/img/iphone_Questionnaires.webp" alt="epro" />
        </div>
      </div>
    </div>
  </div>


  <!-- ROW CUSTOMIZED -->
  <div fxLayout="row wrap" fxLayoutAlign="center">
    <div fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">

      <!-- INTRO -->
      <div class="paragraph alijust">
        <h2 data-aos="fade-down-right" class="alicent">Custom solutions</h2>
        <p data-aos="fade-down-right">If you have a digital solution in mind, which is not on this list, you can <a
            routerLink="/contact-form">contact our team of healthcare developers</a> to discuss your project or request
          a call within 24 hours by using the contact form below.
          ​</p>
      </div>


      <div class="btncontainer buttons">
        <a routerLink="/contact">
          <button mat-flat-button class="btn-hover color-3">
            Contact us
          </button>
        </a>
      </div>

    </div>
  </div>

</div>

<app-footer></app-footer>
